// Libs
import { Outlet } from 'react-router-dom';

// Styles
import './MainLayout.scss';

const MainLayout = () => {
  return (
    <div className="main">
      <Outlet />
    </div>
  );
};

export default MainLayout;
